import { Locales } from "src/shared/config";

export const initialState: {
  locale: Locales;
} = {
  locale: Locales.EN,
};
